// GENERATED by scripts/export-prompts.mjs from the kynward-backend prompt banks
// (src/models/firestarter_arenas.go, src/models/voice_prompt_bank.go). Do not edit by hand: run
// `node scripts/export-prompts.mjs` with a backend checkout beside this repo.
// src/prompts/promptsSync.test.ts fails when this file no longer matches the banks.

export type Beacon = { key: string; chip: string; question: string; hint: string };
export type VoicePrompt = { key: string; question: string };

export const BEACONS: readonly Beacon[] = [
  {
    key: 'swore_never',
    chip: 'Swore never',
    question: "What did you swear you'd never do, and then did?",
    hint: 'The rule, and what finally broke it.',
  },
  {
    key: 'all_wrong',
    chip: 'All wrong',
    question:
      "Someone's doing something all wrong in front of you. What happens, and how long do you last?",
    hint: 'Be honest about the how-long part.',
  },
  {
    key: 'come_to_you',
    chip: 'Come to you',
    question: 'What do people always come to you for, and are they right to?',
    hint: "What they ask, and whether you're the right person for it.",
  },
  {
    key: 'still_brings_up',
    chip: 'They still say',
    question: "What did you do for a friend that they still won't shut up about?",
    hint: "Their version. It's always better than yours.",
  },
  {
    key: 'check_on',
    chip: 'Check on',
    question: "Who's overdue a call from you, and what would you open with?",
    hint: 'Who, and the first line.',
  },
  {
    key: 'pulled_off',
    chip: 'Pulled it off',
    question:
      "What did you pull off recently that you're still a bit smug about, and who did you tell first?",
    hint: 'The win, and the first person who had to hear about it.',
  },
  {
    key: 'get_better_at',
    chip: 'Get better at',
    question: 'What are you trying to get good at next, and how ugly is it so far?',
    hint: 'The thing, and an honest word on the learning curve.',
  },
  {
    key: 'how_you_know',
    chip: 'How you know',
    question: 'How do you know when you actually like someone?',
    hint: 'Your real tell, not the romantic version of it.',
  },
  {
    key: 'liked_them_more',
    chip: 'Won you over',
    question: 'When did someone last do something small that made you like them more?',
    hint: 'Something someone actually did. Small and specific is the point.',
  },
  {
    key: 'nobody_gets',
    chip: 'Nobody gets it',
    question: 'What do you spend money on that nobody else gets, and what are they missing?',
    hint: 'The thing, and the case for it.',
  },
  {
    key: 'lose_a_weekend',
    chip: 'Lose a weekend',
    question: "What would you happily lose a whole weekend to, and when's the next one?",
    hint: "The thing, and whether it's on the calendar yet.",
  },
  {
    key: 'weirdly_good_how',
    chip: 'Weirdly good',
    question: 'What are you weirdly good at, and when did it last come in handy?',
    hint: 'The skill, and the one time it mattered.',
  },
  {
    key: 'day_no_plans',
    chip: 'Day, no plans',
    question: "You've got a whole day and no plans. How does it go?",
    hint: "Walk through it. The real version, not the one you'd post.",
  },
  {
    key: 'how_you_decide',
    chip: 'How you decide',
    question: 'How did you make your last big decision?',
    hint: 'Spreadsheet, coin flip, or gut — walk us through it.',
  },
  {
    key: 'double_check',
    chip: 'Double-check',
    question: 'What do you always double-check, and has it ever caught anything?',
    hint: 'The thing you check, and the one time it mattered — if there was one.',
  },
  {
    key: 'planning_ahead',
    chip: 'Planning ahead',
    question:
      "What's coming up that you've already planned to death, and how far out are we talking?",
    hint: 'The thing, and how much of it is already sorted.',
  },
  {
    key: 'night_didnt_end',
    chip: 'Best night',
    question: "When did you last have a night you didn't want to end?",
    hint: 'Who was there, and what made it.',
  },
  {
    key: 'made_up_tradition',
    chip: 'Our tradition',
    question: 'What tradition have you and your friends made up, and whose fault is it?',
    hint: 'The sillier and more specific, the better.',
  },
  {
    key: 'fell_through',
    chip: 'Fell through',
    question:
      'The thing you were excited about falls through. What now, and how long does it sting?',
    hint: "What you'd do with the night, and the honest recovery time.",
  },
  {
    key: 'cant_wait_for',
    chip: "Can't wait for",
    question:
      'What are you most looking forward to right now, and how long have you been counting down?',
    hint: "The thing, and how long it's been on the calendar.",
  },
  {
    key: 'went_with_gut',
    chip: 'Went with gut',
    question: 'When did you last go with your gut, and who told you not to?',
    hint: "The call, and the person who'd have stopped you.",
  },
  {
    key: 'step_in',
    chip: 'Step in',
    question: "A friend's getting a hard time. What do you do, and how far do you take it?",
    hint: "What you'd actually do, and where you'd stop.",
  },
  {
    key: 'in_ten_years',
    chip: 'In ten years',
    question:
      'What do you want to still be doing every week in ten years, and what would it take to stop you?',
    hint: "The thing you'd keep, and what could pry it loose.",
  },
  {
    key: 'keep_it_easy',
    chip: 'Keep it easy',
    question:
      'What do you go along with just to keep things easy, and how long before it gets to you?',
    hint: 'The thing, and the honest timeline.',
  },
  {
    key: 'long_week',
    chip: 'Long week',
    question:
      "Long week, and a friend wants to go out tonight. Do you go, and where's your head by 10pm?",
    hint: 'The real answer, not the good-friend answer.',
  },
  {
    key: 'cheerfully_bad',
    chip: 'Cheerfully bad',
    question: "What are you cheerfully bad at, and what's the worst it's gone?",
    hint: 'Genuinely bad and fine with it. The incident is the good half.',
  },
  {
    key: 'day_gone_wrong',
    chip: 'Bad day',
    question: "How do you handle a day that's gone wrong?",
    hint: "What you do, not what you'd tell a friend to do.",
  },
];

export const VOICE_PROMPTS: readonly VoicePrompt[] = [
  {
    key: 'say_it_your_way',
    question: 'What do you say far too often? Say it exactly the way you say it.',
  },
  {
    key: 'sit_down_noise',
    question: 'What’s the noise you make when you sit down after a long day? Make it.',
  },
  {
    key: 'voice_you_do',
    question: 'Who do you do a voice for: a pet, a plant, the car? Do the voice.',
  },
  {
    key: 'phone_voice',
    question: 'Answer the phone like it’s someone you love. Now like it’s a number you don’t know.',
  },
  {
    key: 'couldnt_breathe',
    question:
      'What last made you laugh until you couldn’t breathe? Tell it without laughing, if you can.',
  },
  {
    key: 'eleven_pm_call',
    question:
      'A friend calls at 11pm having a rotten night. Pick up. What’s the first thing out of your mouth?',
  },
  {
    key: 'particular_rule',
    question: 'What are you weirdly particular about? Explain the rule like it’s obvious.',
  },
  {
    key: 'argue_with_anyone',
    question:
      'What small thing will you argue about with absolutely anyone? Make your case in one breath.',
  },
  {
    key: 'hype_note',
    question: 'Your friend just got the thing they’ve wanted for ages. Leave them the voice note.',
  },
  {
    key: 'word_only_you_use',
    question:
      'What’s a word only your friends understand? Use it in a sentence, then explain nothing.',
  },
  {
    key: 'nickname_shout',
    question: 'What nickname will you actually answer to? Say it the way they shout it.',
  },
  {
    key: 'walk_in_intro',
    question: 'Introduce the person you’d bring anywhere, like they’re about to walk in.',
  },
  {
    key: 'way_home_note',
    question:
      'The first date went better than expected. Record the voice note you’d send your friend on the way home.',
  },
  {
    key: 'compliment_believed',
    question: 'What’s the compliment you actually believed? Say it the way they said it.',
  },
  {
    key: 'polite_laugh',
    question: 'Do the laugh you use on a first date when the joke isn’t funny. Then the real one.',
  },
  {
    key: 'on_the_way_out',
    question:
      'You’ve just clicked with someone and it’s time to go. Say the goodbye, like they’re standing right there.',
  },
];
